<template>
    <TermsCheck
        :content="listText"
        :isLoading="isLoading"
        :hasTitle="true"
        @goNext="goNext"
    />
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { getAgreeTermsMultiPayChange, postAgreeMultiPayChange } from '@/apis/aplCatlMultiPayChange';
import routeName from '@/router/constant.js';
import TermsCheck from '@/components/template/TermsCheck.vue';

export default {
    components: {
        TermsCheck,
    },
    setup() {
        const router = useRouter();
        const listText = ref('');
        const isLoading = ref(false);

        /** 取得條款內容 */
        getAgreeTermsMultiPayChange().then((res) => {
            listText.value = res.data.agreeTerms.content;
        });

        const goNext = () => {
            isLoading.value = true;
            postAgreeMultiPayChange().then(() => {
                router.push({
                    name: routeName.PAY_OWN_POLICY
                });
            }).finally(() => {
                isLoading.value = false;
            });
        };
        return {
            listText,
            isLoading,
            goNext
        };
    },
};
</script>
